jQuery(function() {
    $('.js-show-full-icon-menu').click(function(e) {
        e.preventDefault();

        var $iconMenu = $(this).closest('.icon-menu');
        var $iconMenuList = $iconMenu.find('.icon-menu__list');

        $iconMenuList.addClass('icon-menu__list--shown');

        setTimeout(function() {
            $iconMenuList.addClass('icon-menu__list--visible');
        }, 25);
    });

    $('body').click(function(e) {
        var $iconMenuList = $('.icon-menu__list');
        if ($(e.target).hasClass('js-show-full-icon-menu') || $(e.target).closest('.js-show-full-icon-menu').length > 0)
            return;

        if ($iconMenuList.hasClass('icon-menu__list--visible')) {
            $iconMenuList
                .removeClass('icon-menu__list--visible')
                .one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
                    $iconMenuList.removeClass('icon-menu__list--shown');
                });
        }
    });
});



// WEBPACK FOOTER //
// ./blocks/icon-menu/icon-menu.js